import { api, apiInstanceList } from '@/service'
import { getHandleResponse, handleRequest, handleRequestError, handleResponseError } from '@/plugins/axios'
apiInstanceList.forEach(item => {
  item.instance.instance.interceptors.request.use(handleRequest, handleRequestError)
  item.instance.instance.interceptors.response.use(getHandleResponse(true), handleResponseError)
})

export const request = api
